import React from 'react';
import { ActionButton } from 'styled_components/Common/ActionButton';
import styled from 'styled-components';

const ModalHeaderStyle = styled.div`
	width: 100%;
	height: 100%;
	.modal-header-wrapper {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		.header-description {
			margin-left: 15px;
		}
		.image-section {
			pointer-events: none;
			#action-button {
				box-shadow: none;
			}
		}
		&.storage-add {
			img {
				margin-top: 10px;
				width: 60px;
				height: 60px;
			}
		}
		&.guest {
			img {
				width: 50px;
				height: 50px;
			}
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		.modal-header-wrapper {
			.header-description {
				margin-left: 40px;
			}

			&.storage-add {
				img {
					margin-top: 12px;
					width: 75px;
					height: 75px;
				}
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		.modal-header-wrapper {
			.header-description {
				margin-left: 50px;
			}
			&.storage-add {
				img {
					margin-top: 20px;
					width: 125px;
					height: 125px;
				}
			}
		}
	}
`;

export const ModalHeader = ({ cypressId, id, image, text, className, svg }) => {
	return (
		<ModalHeaderStyle id={id} className='' data-cy={cypressId}>
			<div className={`modal-header-wrapper ${className}`}>
				{image && (
					<div className='image-section'>
						<ActionButton className={`small `}>{svg ? image : <img src={image} />}</ActionButton>
					</div>
				)}
				<div className='header-description body10'>{text}</div>
			</div>
		</ModalHeaderStyle>
	);
};
